module.exports = __webpack_public_path__ + "img/brand_11.e55ea5a7.png";